<template>
    <o-card class="bg-gradient custom-height">
        <div class="text-end" style="margin-top: -15px;">
            <div class="mb-5">
                <span class="text-white fw-bold">
                    <slot name="card-name"></slot>
                </span>
            </div>
            <div class="d-flex d-inline-block justify-content-between">
                <div>
                    <slot name="icon-big">
                    </slot>
                </div>
                <div class="d-flex d-inline-block">
                <span class="text-white fw-bold me-2 widget-value">
                    <slot name="card-value"></slot>
                </span>
                <div class="mb-2">
                    <span v-if="gain == true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="11" fill="none" viewBox="0 0 19 11">
                            <path fill="#fff" d="M.56 7.872 8.126.539C8.55.178 9.038 0 9.527 0c.488 0 .975.179 1.347.537l7.568 7.333c.545.525.708 1.313.413 1.999-.295.686-.94 1.131-1.76 1.131H1.905c-.77 0-1.466-.446-1.761-1.132a1.78 1.78 0 0 1 .414-1.996Z"/>
                        </svg>
                    </span>
                    <span v-else-if="gain == false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="11" fill="none" viewBox="0 0 19 11">
                            <path fill="#fff" d="m18.44 3.128-7.567 7.333a2.146 2.146 0 0 1-1.4.539c-.488 0-.975-.179-1.347-.537L.559 3.13a1.783 1.783 0 0 1-.414-2C.44.445 1.085 0 1.905 0h15.189c.77 0 1.466.446 1.761 1.132a1.78 1.78 0 0 1-.414 1.996Z"/>
                        </svg>
                    </span>
                    <span v-else>
                    </span>
                </div>
                </div>
            </div>
            </div>
    </o-card>
</template>
<script>
    import { OCard} from '@/components/OmnihControl';
    export default {
    props:[
        'gain'
    ],
    components:{
        OCard,
    }
}
</script>
<style>
    .custom-height{
        min-height: 150px;
        height: 100%;
        flex: 0 0 auto;
    }
    
    /* Desktop font size */
    .widget-value {
        font-size: 24px;
    }
    
    /* Mobile font size */
    @media (max-width: 768px) {
        .widget-value {
            font-size: 18px;
        }
    }
</style>